export default __webpack_public_path__ + "static/media/gallery07.55046c64.png";